// API configuration - uses VITE_API_URL in production, /api in development
export const API_BASE = import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : '/api';
